import React, { Fragment, useEffect, useLayoutEffect, useState } from "react";

// react router dom module
import { Navigate, useLocation, useNavigate } from "react-router-dom";

// components
import Typography from "../Typography/Typography";

// icons
import { BiPowerOff } from "react-icons/bi";
import { HiLockClosed } from "react-icons/hi";

// styled components
import {
  Nav,
  NavList,
  NavListItem,
  SideSection,
  NavLink,
  Icon,
  Header,
  SubHeader,
  Img,
} from "./sidebarStyle";

import { Wrapper } from "../../theme/GlobalStyle";

// data sidebar
import { sidebarData } from "../../data/sidebarData";

// get user data
import { GetUserData } from "../../utils/getUserData";
import { useViewportWidth } from "../../hooks/useViewportWidth";
import { setHeaderAPI } from "../../services/apiConfig";
import ConfirmDialog from "../Dialog/ConfirmDialog";
import Loading from "../Loadings/LoadingTable";
import { getUserRoll } from "../../helper/getUserRoll";
import { AllRoutes } from "../../constant/routes/AllRoutes";

const SideHeader = ({ isShowSidebar, setIsShowSidebar }) => {
  const [isLogout, setIsLogout] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("profile");
    navigate("/login", { replace: true });
    setIsLogout(false);
    window.location.reload();
  };

  return (
    <Fragment>
      <Header isShowSidebar={isShowSidebar}>
        <Typography size="14px" isOpenSubMenu={isShowSidebar}>
          پنل همکار
        </Typography>

        <Wrapper sidebar>
          <Icon onClick={() => setIsLogout(true)}>
            <BiPowerOff />
          </Icon>
          <Icon>
            <HiLockClosed className="lock" />
          </Icon>

          <Icon className="close">
            <Typography onClick={() => setIsShowSidebar(!isShowSidebar)}>
              x
            </Typography>
          </Icon>
        </Wrapper>
      </Header>
      {isLogout && (
        <ConfirmDialog
          show={isLogout}
          handleClose={() => setIsLogout(false)}
          title="خروج از پنل"
          onSuccess={handleLogout}
          onFeild={() => setIsLogout(false)}
          successTitle="خروج"
          feildTitle="منصرف شدم"
        />
      )}
    </Fragment>
  );
};

const SideSubHeader = ({ isShowSidebar }) => {
  const userInfo = GetUserData();
  const name = userInfo?.users[0]?.FirstName;
  const family = userInfo?.users[0]?.LastName;
  const imageProfile = userInfo?.users[0]?.Image;
  return (
    <SubHeader>
      <Wrapper>
        <Img
          src={`https://api.behsod.com/thumbnail/Profile/${imageProfile}`}
          alt="profile"
        />
        <Typography
          isOpenSubMenu={isShowSidebar}
          size="14px"
          space=".5rem"
          weight="bold"
        >
          {`${name} ${family}`}
        </Typography>
      </Wrapper>
    </SubHeader>
  );
};

const SideMenu = ({ sidebarData, isShowSidebar, setIsShowSidebar }) => {
  const [data, setData] = useState([]);

  const location = useLocation();
  const width = useViewportWidth();

  const getUser = getUserRoll();

  const isAccessSide = (navRolls) => {
    let isAcess = false;
    for (let i = 0; i < navRolls.length; i++) {
      const isExit = getUser?.includes(navRolls[i]);
      if (isExit) {
        isAcess = true;
        break;
      }
    }

    return isAcess;
  };

  return (
    <Nav>
      <NavList>
        {sidebarData?.map((item, index) => {
          if (item?.role[0] === "SIMPLE") {
            return (
              <NavListItem
                menu={true}
                key={index}
                // className={location.pathname === item.path ? "active1" : ""}
                className={
                  item?.child?.includes(location.pathname) ? "active1" : ""
                }
                onClick={() =>
                  width < 500 ? setIsShowSidebar(!isShowSidebar) : ""
                }
              >
                <NavLink to={item.path}>
                  <Icon>{item.icon}</Icon>
                  <Typography
                    isOpenSubMenu={isShowSidebar}
                    size="14px"
                    space=".1rem"
                  >
                    {item.name}
                  </Typography>
                </NavLink>
              </NavListItem>
            );
          }
          return isAccessSide(item.role) ? (
            <NavListItem
              menu={true}
              key={index}
              // className={location.pathname === item.path ? "active1" : ""}
              className={
                item?.child?.includes(location.pathname) ? "active1" : ""
              }
              onClick={() =>
                width < 500 ? setIsShowSidebar(!isShowSidebar) : ""
              }
            >
              <NavLink to={item.path}>
                <Icon>{item.icon}</Icon>
                <Typography
                  isOpenSubMenu={isShowSidebar}
                  size="14px"
                  space=".1rem"
                >
                  {item.name}
                </Typography>
              </NavLink>
            </NavListItem>
          ) : null;
        })}
      </NavList>
    </Nav>
  );
};

const Siderbar = ({ isShowSidebar, setIsShowSidebar, fixed, setFixed }) => {
  const handleMouesEnter = () => {
    setIsShowSidebar(false);
  };

  return (
    <SideSection
      id="aside"
      isShowSidebar={isShowSidebar}
      fixed={fixed}
      onMouseEnter={handleMouesEnter}
    >
      <SideHeader
        setIsShowSidebar={setIsShowSidebar}
        isShowSidebar={isShowSidebar}
      />
      <SideSubHeader isShowSidebar={isShowSidebar} />
      <SideMenu
        setIsShowSidebar={setIsShowSidebar}
        sidebarData={sidebarData}
        isShowSidebar={isShowSidebar}
        setFixed={setFixed}
      />
    </SideSection>
  );
};

export default Siderbar;
